/**
 * Veeroute.Delivery
 * Veeroute Delivery API
 *
 * The version of the OpenAPI document: 3.15.183137
 * Contact: support@veeroute.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Service version.
 */
export interface VersionResultDelivery { 
    /**
     * Major version. Contains incompatible API changes. 
     */
    major: number;
    /**
     * Minor version. Contains new functionality in a backwards compatible manner. 
     */
    minor: number;
    /**
     * Build version. Contains backwards compatible bug fixes and docs update. 
     */
    build: number;
}

